import { Colors } from './colors';

/**
 * Design tokens shared by every component. Values are deliberately few:
 * one radius scale, one shadow scale, one motion curve, so screens stay
 * consistent with each other.
 */
export const Radius = {
  /** chips, small controls */
  sm: '0.5rem',
  /** buttons, inputs, list cards */
  md: '0.75rem',
  /** content cards */
  lg: '1rem',
  /** sheets, dialogs, hero panels */
  xl: '1.25rem',
  pill: '999px',
};

export const Shadow = {
  card: '0 1px 2px rgba(16, 42, 67, 0.06), 0 10px 24px -14px rgba(16, 42, 67, 0.28)',
  raised:
    '0 2px 6px rgba(16, 42, 67, 0.08), 0 18px 40px -18px rgba(16, 42, 67, 0.35)',
  nav: '0 -1px 0 rgba(16, 42, 67, 0.06), 0 -10px 30px -18px rgba(16, 42, 67, 0.3)',
  focus: `0 0 0 4px ${Colors.CAPRI_BLUE}22`,
  brand: '0 10px 24px -8px rgba(29, 88, 131, 0.55)',
};

export const Motion = {
  fast: '150ms cubic-bezier(0.2, 0, 0, 1)',
  base: '220ms cubic-bezier(0.2, 0, 0, 1)',
};

/** Standard interactive control heights (unchanged from the original UI). */
export const ControlHeight = {
  large: '3.375rem',
  medium: '2.6875rem',
  input: '3.5rem',
};

/** Visible keyboard focus ring, used by every custom control. */
export const focusRing = `
  &:focus-visible {
    outline: 2px solid ${Colors.CAPRI_BLUE};
    outline-offset: 2px;
  }
`;

/** Reset for elements that are rendered as <button> but styled as content. */
export const unstyledButton = `
  appearance: none;
  background: none;
  border: 0;
  padding: 0;
  margin: 0;
  font: inherit;
  color: inherit;
  text-align: inherit;
  cursor: pointer;
`;
